// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"73bcde21","238":"95b5255a","557":"8f442b24","701":"962eef42","732":"4b63e140"}[chunkId] + ".chunk.js";
};